import React from 'react';
import { Globe, LogIn, LogOut, Settings, ShieldCheck, BookOpen, UserCheck, Bell, BellRing } from 'lucide-react';
import { G1 } from '../../config/styles';

export default function Header({
  settings, employee, customer, lang, page, isRTL,
  perms, unreadCount, showNotifPanel,
  onLogoClick, onSetPage, onToggleLang,
  onOpenNotif, onOpenCustModal, onLogoutEmp, onLogoutCust, t,
}) {
  return (
    <div style={{
      background: 'rgba(10,8,30,0.72)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      padding: '7px 16px',
      position: 'sticky', top: 0, zIndex: 40,
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      boxShadow: '0 2px 32px rgba(0,0,0,0.25)',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', flexShrink: 0 }} onClick={() => onSetPage('home')}>
          <LogoImg onLogoClick={onLogoClick} settings={settings} />
          <span style={{ fontSize: '15px', fontWeight: '800', background: 'linear-gradient(135deg,#a78bfa,#60a5fa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', letterSpacing: '-0.3px', whiteSpace: 'nowrap' }}>
            {t.site}
          </span>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flexWrap: 'nowrap', overflow: 'hidden' }}>

          {/* Employee */}
          {employee && (
            <>
              <div style={{ padding: '5px 12px', background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.85)', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px', border: '1px solid rgba(255,255,255,0.12)' }}>
                <ShieldCheck size={11} style={{ color: '#a78bfa' }} />
                {lang === 'ar' ? employee.name_ar : employee.name_en}
              </div>
              <div style={{ position: 'relative' }}>
                <button onClick={onOpenNotif}
                  style={{ padding: '7px 10px', background: showNotifPanel ? 'rgba(102,126,234,0.3)' : 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.85)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', transition: 'all .2s' }}>
                  {unreadCount > 0 ? <BellRing size={14} /> : <Bell size={14} />}
                  {unreadCount > 0 && (
                    <span style={{ position: 'absolute', top: '-4px', [isRTL ? 'left' : 'right']: '-4px', background: '#ef4444', color: 'white', borderRadius: '50%', width: '16px', height: '16px', fontSize: '9px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                  )}
                </button>
              </div>
              {perms.can_view_dashboard && (
                <button onClick={() => onSetPage('dashboard')}
                  style={{ padding: '7px 12px', background: page === 'dashboard' ? 'rgba(102,126,234,0.35)' : 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.85)', border: `1px solid ${page === 'dashboard' ? 'rgba(102,126,234,0.5)' : 'rgba(255,255,255,0.1)'}`, borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 'bold', transition: 'all .2s' }}>
                  <Settings size={12} /> {t.dashboard}
                </button>
              )}
              <button onClick={onLogoutEmp}
                style={{ padding: '7px 12px', background: 'rgba(239,68,68,0.15)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.25)', borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                <LogOut size={12} /> {t.logout}
              </button>
            </>
          )}

          {/* Customer */}
          {customer && !employee && (
            <>
              <div style={{ padding: '5px 12px', background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.85)', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px', border: '1px solid rgba(255,255,255,0.1)' }}>
                <UserCheck size={12} style={{ color: customer.isGuest ? '#fbbf24' : '#a78bfa' }} />
                {customer.name}
              </div>
              {!customer.isGuest && (
                <button onClick={() => onSetPage('mycourses')}
                  style={{ padding: '7px 12px', background: page === 'mycourses' ? 'rgba(102,126,234,0.35)' : 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.85)', border: `1px solid ${page === 'mycourses' ? 'rgba(102,126,234,0.5)' : 'rgba(255,255,255,0.1)'}`, borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 'bold', transition: 'all .2s' }}>
                  <BookOpen size={12} /> {t.myCourses}
                </button>
              )}
              <button onClick={onLogoutCust}
                style={{ padding: '7px 12px', background: 'rgba(239,68,68,0.15)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.25)', borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                <LogOut size={12} /> {t.logout}
              </button>
            </>
          )}

          {/* Not logged in */}
          {!customer && !employee && (
            <button onClick={onOpenCustModal}
              style={{ padding: '6px 12px', background: 'linear-gradient(135deg,#667eea,#764ba2)', color: 'white', border: 'none', borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 'bold', boxShadow: '0 4px 16px rgba(102,126,234,0.4)', transition: 'all .2s', whiteSpace: 'nowrap' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-1px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
              <LogIn size={13} /> {t.custLogin}
            </button>
          )}

          {/* Lang */}
          <button onClick={onToggleLang}
            style={{ padding: '6px 9px', background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.7)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '3px', fontSize: '11px', fontWeight: 'bold', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
            <Globe size={11} /> {lang === 'ar' ? 'EN' : 'AR'}
          </button>
        </div>
      </div>
    </div>
  );
}

function LogoImg({ onLogoClick, settings }) {
  const [err, setErr] = React.useState(false);
  const size = 30;
  const src = (settings && settings.logo_url) ? settings.logo_url : '/logo.png';
  React.useEffect(() => { setErr(false); }, [src]);
  return err
    ? <div onClick={onLogoClick} style={{ width: size, height: size, background: 'linear-gradient(135deg,#667eea,#764ba2)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, cursor: 'pointer' }}>💎</div>
    : <img src={src} alt="logo" onClick={onLogoClick} onError={() => setErr(true)} style={{ width: size, height: size, objectFit: 'contain', borderRadius: '8px', cursor: 'pointer' }} />;
}
